import { render, staticRenderFns } from "./ItemAddBtn.vue?vue&type=template&id=679107dc&scoped=true&"
import script from "./ItemAddBtn.vue?vue&type=script&lang=js&"
export * from "./ItemAddBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679107dc",
  null
  
)

export default component.exports